import { AudiencesQuery, ViewingPoliciesQuery } from '../types/generated/graphql';

export type ViewingPolicy = ViewingPoliciesQuery['viewingPolicies'][number];

export type Audience = AudiencesQuery['audiences'][number];

export enum FeedPolicySearchType {
  DATE = 'DATE',
  GAME = 'GAME',
  MEDIA = 'MEDIA',
}
